import { render, staticRenderFns } from "./AddEditShift.vue?vue&type=template&id=0521fdfe&scoped=true&"
import script from "./AddEditShift.vue?vue&type=script&lang=js&"
export * from "./AddEditShift.vue?vue&type=script&lang=js&"
import style0 from "./AddEditShift.vue?vue&type=style&index=0&id=0521fdfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521fdfe",
  null
  
)

export default component.exports